import { c as _c } from "react/compiler-runtime";
import type { EntityOnboarding } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import type { SubsectionType as Subsection } from '@/components/entity-onboarding-details';
import { useEntityContext } from '@/entities/components/details/hooks/use-entity-context';
type SubsectionItem = {
  key: Subsection;
  title: string;
  isShown: boolean;
};
const useSubsections = onboarding => {
  const $ = _c(86);
  const {
    t
  } = useTranslation("entity-details");
  const {
    kind: entityKind
  } = useEntityContext();
  const isPerson = entityKind === "person";
  const isBusiness = entityKind === "business";
  const isCompleteKybOnboarding = onboarding.kind === "kyb" && (onboarding.status === "pass" || onboarding.status === "fail");
  const hasBusinessInsights = isBusiness && isCompleteKybOnboarding && Boolean(onboarding.seqno);
  let t0;
  if ($[0] !== t) {
    t0 = t(_temp);
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      key: "more-information",
      title: t0,
      isShown: true
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t(_temp2);
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== isPerson || $[7] !== t2) {
    t3 = {
      key: "user-data",
      title: t2,
      isShown: isPerson
    };
    $[6] = isPerson;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t) {
    t4 = t(_temp3);
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== isBusiness || $[12] !== t4) {
    t5 = {
      key: "business-data",
      title: t4,
      isShown: isBusiness
    };
    $[11] = isBusiness;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t) {
    t6 = t(_temp4);
    $[14] = t;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t6) {
    t7 = {
      key: "documents",
      title: t6,
      isShown: true
    };
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t) {
    t8 = t(_temp5);
    $[18] = t;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const t9 = onboarding.kind !== "document";
  let t10;
  if ($[20] !== t8 || $[21] !== t9) {
    t10 = {
      key: "rules",
      title: t8,
      isShown: t9
    };
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t) {
    t11 = t(_temp6);
    $[23] = t;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11) {
    t12 = {
      key: "risk-signals",
      title: t11,
      isShown: true
    };
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t) {
    t13 = t(_temp7);
    $[27] = t;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== isPerson || $[30] !== t13) {
    t14 = {
      key: "duplicate-data",
      title: t13,
      isShown: isPerson
    };
    $[29] = isPerson;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t) {
    t15 = t(_temp8);
    $[32] = t;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== isPerson || $[35] !== t15) {
    t16 = {
      key: "field-validations",
      title: t15,
      isShown: isPerson
    };
    $[34] = isPerson;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t) {
    t17 = t(_temp9);
    $[37] = t;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== hasBusinessInsights || $[40] !== t17) {
    t18 = {
      key: "business-details",
      title: t17,
      isShown: hasBusinessInsights
    };
    $[39] = hasBusinessInsights;
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== t) {
    t19 = t(_temp10);
    $[42] = t;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== hasBusinessInsights || $[45] !== t19) {
    t20 = {
      key: "people",
      title: t19,
      isShown: hasBusinessInsights
    };
    $[44] = hasBusinessInsights;
    $[45] = t19;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== t) {
    t21 = t(_temp11);
    $[47] = t;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  let t22;
  if ($[49] !== hasBusinessInsights || $[50] !== t21) {
    t22 = {
      key: "registrations",
      title: t21,
      isShown: hasBusinessInsights
    };
    $[49] = hasBusinessInsights;
    $[50] = t21;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  if ($[52] !== t) {
    t23 = t(_temp12);
    $[52] = t;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== hasBusinessInsights || $[55] !== t23) {
    t24 = {
      key: "watchlist",
      title: t23,
      isShown: hasBusinessInsights
    };
    $[54] = hasBusinessInsights;
    $[55] = t23;
    $[56] = t24;
  } else {
    t24 = $[56];
  }
  let t25;
  if ($[57] !== t) {
    t25 = t(_temp13);
    $[57] = t;
    $[58] = t25;
  } else {
    t25 = $[58];
  }
  let t26;
  if ($[59] !== hasBusinessInsights || $[60] !== t25) {
    t26 = {
      key: "offices",
      title: t25,
      isShown: hasBusinessInsights
    };
    $[59] = hasBusinessInsights;
    $[60] = t25;
    $[61] = t26;
  } else {
    t26 = $[61];
  }
  let t27;
  if ($[62] !== t) {
    t27 = t(_temp14);
    $[62] = t;
    $[63] = t27;
  } else {
    t27 = $[63];
  }
  let t28;
  if ($[64] !== t27) {
    t28 = {
      key: "device-insights",
      title: t27,
      isShown: true
    };
    $[64] = t27;
    $[65] = t28;
  } else {
    t28 = $[65];
  }
  let t29;
  if ($[66] !== t) {
    t29 = t(_temp15);
    $[66] = t;
    $[67] = t29;
  } else {
    t29 = $[67];
  }
  let t30;
  if ($[68] !== t29) {
    t30 = {
      key: "other-insights",
      title: t29,
      isShown: true
    };
    $[68] = t29;
    $[69] = t30;
  } else {
    t30 = $[69];
  }
  let t31;
  if ($[70] !== t1 || $[71] !== t10 || $[72] !== t12 || $[73] !== t14 || $[74] !== t16 || $[75] !== t18 || $[76] !== t20 || $[77] !== t22 || $[78] !== t24 || $[79] !== t26 || $[80] !== t28 || $[81] !== t3 || $[82] !== t30 || $[83] !== t5 || $[84] !== t7) {
    const subsections = [t1, t3, t5, t7, t10, t12, t14, t16, t18, t20, t22, t24, t26, t28, t30];
    t31 = subsections.filter(_temp16);
    $[70] = t1;
    $[71] = t10;
    $[72] = t12;
    $[73] = t14;
    $[74] = t16;
    $[75] = t18;
    $[76] = t20;
    $[77] = t22;
    $[78] = t24;
    $[79] = t26;
    $[80] = t28;
    $[81] = t3;
    $[82] = t30;
    $[83] = t5;
    $[84] = t7;
    $[85] = t31;
  } else {
    t31 = $[85];
  }
  return t31;
};
export default useSubsections;
function _temp($) {
  return $.onboardings.moreInformation.title;
}
function _temp2($_0) {
  return $_0.onboardings.userData.title;
}
function _temp3($_1) {
  return $_1.onboardings.businessData.title;
}
function _temp4($_2) {
  return $_2.onboardings.documents.title;
}
function _temp5($_3) {
  return $_3.onboardings.rules.title;
}
function _temp6($_4) {
  return $_4.onboardings.riskSignals.title;
}
function _temp7($_5) {
  return $_5.duplicateData.title;
}
function _temp8($_6) {
  return $_6.onboardings.fieldValidations.title;
}
function _temp9($_7) {
  return $_7.onboardings.businessDetails.title;
}
function _temp10($_8) {
  return $_8.onboardings.people.title;
}
function _temp11($_9) {
  return $_9.onboardings.registrations.title;
}
function _temp12($_10) {
  return $_10.onboardings.watchlist.title;
}
function _temp13($_11) {
  return $_11.onboardings.offices.title;
}
function _temp14($_12) {
  return $_12.deviceInsights.title;
}
function _temp15($_13) {
  return $_13.otherInsights.title;
}
function _temp16(subsection) {
  return subsection.isShown;
}